import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FilterOperatorErrorRecord from '../../filterQueryFormat/FilterOperatorErrorRecord';
import { useEditorActions } from '../../hooks/useEditorActions';
import { usePropertyChangedNameAndValueFilter } from '../../hooks/usePropertyChangedNameAndValueFilter';
import { useStrategy } from '../../hooks/useStrategy';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import ConditionBox from '../common/ConditionBox';
import ConditionError from '../common/ConditionError';
import FilterOperatorPropertyInput from '../operator/FilterOperatorPropertyInput';
import EditorConditionActionsContainer from './EditorConditionActionsContainer';
import EditorConditionInputs from './EditorConditionInputs';
import EditorIncludeObjectsWithNoValueSetInput from './EditorIncludeObjectsWithNoValueSetInput';
import EditorUIFieldSet from './EditorUIFieldSet';
import FilterInfoWarnings from '../common/FilterInfoWarnings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const EditorPropertyNameAndValueCondition = props => {
  const {
    condition,
    conditionPath,
    filterFamily,
    getIsUngated,
    inputUse
  } = props;
  const {
    getValueResolver,
    isIncludeObjectsWithNoValueSetCheckboxEnabled
  } = useStrategy();
  const {
    hydratedCondition,
    onPropertyNameChange,
    onPropertyValueOperatorChange,
    onPropertyValueValueChange
  } = usePropertyChangedNameAndValueFilter(filterFamily, condition, conditionPath);
  const {
    onConditionDelete
  } = useEditorActions();
  const resolver = getValueResolver(hydratedCondition.referencedObjectTypeId, hydratedCondition);
  return /*#__PURE__*/_jsx(EditorConditionActionsContainer, {
    condition: hydratedCondition,
    conditionPath: conditionPath,
    filterFamily: filterFamily,
    onConditionDelete: () => onConditionDelete(conditionPath),
    children: /*#__PURE__*/_jsx(ConditionBox, {
      children: /*#__PURE__*/_jsxs(EditorUIFieldSet, {
        legend: I18n.text('customerDataFiltersUI.propertyValueChangedEvent.editorPropertyName'),
        children: [/*#__PURE__*/_jsx(FilterOperatorPropertyInput, {
          condition: hydratedCondition,
          error: FilterOperatorErrorRecord(),
          onChange: onPropertyNameChange,
          resolver: resolver,
          fieldName: "propertyName",
          getIsUngated: getIsUngated,
          inputUse: inputUse
        }), Boolean(hydratedCondition.propertyValue) && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs(View, {
            marginBlockStart: "600",
            as: "div",
            children: [/*#__PURE__*/_jsx(Text, {
              as: "h6",
              marginBlockEnd: "0",
              textTransform: "uppercase",
              color: "icon-core-subtle",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "customerDataFiltersUI.propertyValueChangedEvent.editorPropertyNewValue"
              })
            }), /*#__PURE__*/_jsx(EditorConditionInputs
            // @ts-expect-error doesn't know that `propertyValue` is guaranteed in `hydratedCondition`
            , {
              condition: hydratedCondition.propertyValue,
              filterFamily: filterFamily,
              objectTypeId: typeof hydratedCondition.referencedObjectTypeId === 'string' ? hydratedCondition.referencedObjectTypeId : undefined,
              inputUse: inputUse,
              onConditionOperatorChange: onPropertyValueOperatorChange,
              onConditionValueChange: onPropertyValueValueChange,
              children: isIncludeObjectsWithNoValueSetCheckboxEnabled && /*#__PURE__*/_jsx(EditorIncludeObjectsWithNoValueSetInput
              // @ts-expect-error doesn't know that `propertyValue` is guaranteed in `hydratedCondition`
              , {
                condition: hydratedCondition.propertyValue,
                conditionPath: conditionPath
                // @ts-expect-error doesn't know that `propertyValue` is guaranteed in `hydratedCondition`
                ,
                filterFamily: hydratedCondition.referencedObjectTypeId,
                onChange: onPropertyValueValueChange,
                spaceStyleProps: {
                  marginBlockStart: '200'
                }
              })
            })]
          }), /*#__PURE__*/_jsx(FilterInfoWarnings
          // @ts-expect-error doesn't know that `propertyValue` is guaranteed in `hydratedCondition`
          , {
            condition: hydratedCondition.propertyValue
          }), /*#__PURE__*/_jsx(ConditionError
          // @ts-expect-error doesn't know that `propertyValue` is guaranteed in `hydratedCondition`
          , {
            condition: hydratedCondition.propertyValue
          })]
        })]
      })
    })
  });
};
export default EditorPropertyNameAndValueCondition;